module.exports = __webpack_public_path__ + "img/EU_ESI-Fonds_rechts.55c4d9a5.jpg";